__turbopack_context__.v({
  "name": "header-name-module__iFdQ4G__name",
  "prefix": "header-name-module__iFdQ4G__prefix",
  "prefixLogo": "header-name-module__iFdQ4G__prefixLogo",
});
